import React, { useContext, useRef, useState, useEffect } from 'react'
import Map from 'ol/Map'
import View from 'ol/View'
import 'ol/ol.css';
import OSM from 'ol/source/OSM'
import withConfig from '../../wrappers/withConfig'
import Circle from 'ol/style/Circle';
import Fill from 'ol/style/Fill';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import VectorSource from 'ol/source/Vector';
import {Icon, Style} from 'ol/style';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
import reactDom from 'react-dom'
import ImageLayer from 'ol/layer/Image';
import ImageArcGISRest from 'ol/source/ImageArcGISRest';
import LayerSwitcher from 'ol-layerswitcher';
import {FullScreen, defaults as defaultControls} from 'ol/control';
import 'ol-layerswitcher/dist/ol-layerswitcher.css';
// import MapMarker from '../../images/MapMarker.png';


const FeatureMap = withConfig(({ config, loading, lat, lon }) => {

    // create internal state + refs
    const mapRef = useRef(null)
    const [map, setMap] = useState(null)
    const mapmark = require('../../images/MapMarker.png');

    // on load, set up the map
    useEffect(() => {
        const map = new Map({
            target: mapRef.current,
            controls: [new FullScreen()],
            layers: [
                new TileLayer({
                    title: 'Map',
                    source: new OSM(),
                    visible: true,
                    type: "base"
                }),
                new ImageLayer({
                    title: 'Satellite',
                    source: new ImageArcGISRest({
                        ratio: 1,
                        url: 'http://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer',
                    }),
                    visible: false,
                    opacity: 1,
                    type: "base"
                    })
            ],
            view: new View({
                projection: 'EPSG:4326',
                center: [lon, lat],
                zoom: 7
            })
        })

        setMap(map)
    }, [ 
        lat, 
        lon
    ])

    useEffect(() => {
        if (map && mapRef) {
            map.setSize(mapRef.current.clientWidth, mapRef.current.clientHeight)
            map.updateSize()
        }
    }, [loading, map, mapRef])

    useEffect(() => {
        if (lat && lon && map) {
            const iconFeature = new Feature({
                geometry: new Point([lon, lat]),
                name: 'Null Island',
                population: 4000,
                rainfall: 500,
              });
              
              const iconStyle = new Style({
                image: new Icon({
                  anchor: [0.5, 46],
                  anchorXUnits: 'fraction',
                  anchorYUnits: 'pixels',
                  src: mapmark,
                  height: [5]
                }),
              });

              iconFeature.setStyle(iconStyle);
              
              const vectorSource = new VectorSource({
                features: [iconFeature],
              });
              
              const vectorLayer = new VectorLayer({
                source: vectorSource,
              });

              const layerSwitcher = new LayerSwitcher({
                reverse: false,
                groupSelectStyle: 'group',
                renderPanel: true,
                // startActive: true,
              });
              
                map.addControl(layerSwitcher);
  
                map.addLayer(vectorLayer)
        }
    }, [map, lat, lon])

    // if (loading) {
    //     return null
    // }
    

    return (
        <div className="mapFlexWrapper">
            <div className="mapWrapper">
                <div
                    id="map"
                    ref={mapRef}
                    className={`mapContainer`}
                ></div>
            </div>
        </div>
    )
})

export default FeatureMap